export var AVATAR_GROUP = 'compass-ui-v2-avatar-group';